export default {
  baseUrl: "https://omanghub-api.cubettech.in",
  anabotApiBase: "https://anabotv2.cubettech.in",
  portalUrl: "https://omanghub.cubettech.in",
  productionUrl: "https://omanghub.cubettech.in",
  s3Url: "https://omangapp-uat.s3.amazonaws.com"
};
export const qbAdminId = "132060393";

const siteConfig = {
  siteName: "Omang",
  siteIcon: "ion-flash",
  footerText: `Omang ©${new Date().getFullYear()}`,
};
const themeConfig = {
  topbar: "themedefault",
  sidebar: "themedefault",
  layout: "themedefault",
  theme: "themedefault",
};
const language = "english";
export { siteConfig, language, themeConfig };
